import { createTheme } from "@mui/material/styles";
import { Red_Hat_Text } from "next/font/google";
import {
	MuiAccordion,
	MuiAccordionDetails,
	MuiAccordionSummary,
} from "./components/mui.accordion";
import { MuiAlert } from "./components/mui.alert";
import { MuiAppBar } from "./components/mui.app.bar";
import { MuiAutocomplete } from "./components/mui.autocomplete";
import { MuiButton } from "./components/mui.button";
import { MuiCard, MuiCardContent, MuiCardHeader } from "./components/mui.card";
import { MuiChip } from "./components/mui.chip";
import { MuiDataGrid } from "./components/mui.data.grid";
import {
	MuiDialog,
	MuiDialogActions,
	MuiDialogContent,
	MuiDialogTitle,
} from "./components/mui.dialog";
import { MuiFormControlLabel } from "./components/mui.form.control.label";
import { MuiInputLabel } from "./components/mui.input.label";
import { MuiLink } from "./components/mui.link";
import { MuiListItemIcon } from "./components/mui.list";
import { MuiMenu, MuiMenuItem } from "./components/mui.menu";
import { MuiOutlinedInput } from "./components/mui.outlined.input";
import {
	MuiCircularProgress,
	MuiLinearProgress,
} from "./components/mui.progress";
import { MuiSkeleton } from "./components/mui.skeleton";
import { MuiTextField } from "./components/mui.text.field";
import { MuiTypography } from "./components/mui.typography";
import { lightPalette } from "./palette";

const redHatText = Red_Hat_Text({
	weight: ["300", "400", "500", "600", "700"],
	subsets: ["latin"],
	display: "swap",
});

export const createMuiTheme = () =>
	createTheme({
		colorSchemes: {
			light: {
				palette: lightPalette,
			},
		},
		cssVariables: {
			colorSchemeSelector: "class",
		},
		typography: {
			fontFamily: redHatText.style.fontFamily,
		},
		components: {
			MuiAccordion,
			MuiAccordionDetails,
			MuiAccordionSummary,
			MuiAlert,
			MuiAppBar,
			MuiAutocomplete,
			MuiButton,
			MuiCard,
			MuiCardHeader,
			MuiCardContent,
			MuiChip,
			MuiCircularProgress,
			MuiDataGrid,
			MuiDialog,
			MuiDialogTitle,
			MuiDialogContent,
			MuiDialogActions,
			MuiFormControlLabel,
			MuiInputLabel,
			MuiLinearProgress,
			MuiLink,
			MuiListItemIcon,
			MuiMenu,
			MuiMenuItem,
			MuiOutlinedInput,
			MuiSkeleton,
			MuiTextField,
			MuiTypography,
		},
	});
